import { memo, useMemo } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import classNames from 'classnames';

const MultiSelectTrainingGroup = (props) => {
     const {
          item,
          listTrainingGroup,
          isNoOption,
          disableOptions,
          isLoadingSeatTable,
          isLoadingChangeGroups,
          handleButtonAddNew,
          handleChangeMultiSelect,
          handleFilterOptionsMultiselect,
     } = props;

     const newOptions = useMemo(() => {
          const _newOptions = listTrainingGroup?.map((item) => ({ ...item, disabled: isLoadingChangeGroups }));

          _newOptions.push({
               label: (
                    <button className="btn-add-group" onClick={() => handleButtonAddNew(item)}>
                         Create a Group to Organize Your Training
                    </button>
               ),
               value: 'addTrainingGroup',
          });
          return _newOptions;
     }, [handleButtonAddNew, isLoadingChangeGroups, item, listTrainingGroup]);

     const selectedValues = useMemo(() => {
          const memberTrainingGroup = item?.user?.trainingGroups || [];

          const memberTrainingGroupIdObj = {};
          memberTrainingGroup.forEach((item) => {
               memberTrainingGroupIdObj[item.id] = item;
          });

          const _selectedValues = newOptions.filter((option) => !!memberTrainingGroupIdObj[option.value]);
          return _selectedValues;
     }, [item?.user?.trainingGroups, newOptions]);

     if (!item?.user?.trainingGroups) return null;

     return (
          <MultiSelect
               labelledBy="Select"
               options={newOptions}
               value={selectedValues}
               onChange={(e) => handleChangeMultiSelect(e, item, selectedValues)}
               filterOptions={handleFilterOptionsMultiselect}
               hasSelectAll={false}
               className={classNames('multi-select-add-new multi-select-add-new__on-seat', {
                    'no-option': isNoOption,
               })}
               disabled={disableOptions || isLoadingSeatTable}
               isLoading={isLoadingChangeGroups}
               overrideStrings={{ search: 'Type here to filter...' }}
               onMenuToggle={(isOpen) => {
                    if (isOpen) {
                         const element = document.querySelector('.options');

                         if (element?.scrollHeight > element?.clientHeight) {
                              element.classList.add('is-scroll');
                         } else {
                              element.classList.remove('is-scroll');
                         }
                    }
               }}
          />
     );
};

export default memo(MultiSelectTrainingGroup);
